var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.$t('login.loginMessage1'))+" "),_c('a',{attrs:{"data-testid":"login-button"},on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t('login.loginMessage2')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }